
function Loading() {
    return <>
<p className='load'><i class="fa-solid fa-circle-notch fa-spin"></i></p>
    </>;

};

export default Loading;